import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { airPriceWatchOptInQuery } from './priceWatchQueries'
import { LONG_TRIP_TYPE_FORMAT } from '../../../../common/constants/itinerary'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'

const requestPriceWatchOptIn = async ({
  plfCode,
  appCode,
  dealPrice,
  dealType,
  departDate,
  destCityId,
  email,
  originCityId,
  returnDate,
  tripType,
  destCityCode,
  destCityName,
  originCityCode,
  originCityName,
  useLocalFlyql = false,
  // No default value fot numOfStopsFilter to be treated as an unfiltered search.
  numOfStopsFilter,
  cabinClass = 'Economy',
}) => {
  const operationName = 'airPriceWatchOptInResponse'
  try {
    const priceWatchOptInResponse = await axios({
      url: getGraphURL({ operationName, useLocalFlyql }),
      method: 'post',
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': globalThis.PCLN_BOOTSTRAP_DATA?.appVersion || 'development',
      },
      data: {
        operationName,
        variables: {
          input: {
            appCode,
            dealPrice,
            dealType,
            departDate,
            destCityId,
            destCityCode,
            destCityName,
            email,
            originCityId,
            originCityCode,
            originCityName,
            returnDate,
            tripType: LONG_TRIP_TYPE_FORMAT[tripType],
            requestId: uuidv4(),
            plfCode,
            disclaimerText: 'N/A', //not showing disclaimer currently
            placement: 'FLY-SEARCH',
            numOfStopsFilter: numOfStopsFilter,
            cabinClass: cabinClass,
          },
        },
        query: airPriceWatchOptInQuery,
      },
    })
    return priceWatchOptInResponse?.data?.data?.airPriceWatchOptInResponse
  } catch (err) {
    return {
      status: 'ERROR',
      err: err,
    }
  }
}

export { requestPriceWatchOptIn }
